import { Component, Inject, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { FakturagodkendelseModalData } from "./../model/fakturagodkendelse-modal-data.model";
import { FakturagodkendelseModalFormBuilder } from "./fakturagodkendelse-modal-form-builder";

@Component({
    selector: "fakturagodkendelse-modal",
    styleUrls: ["./fakturagodkendelse-modal.component.scss"],
    templateUrl: "./fakturagodkendelse-modal.component.html"
})
export class FakturagodkendelseModalComponent implements OnInit {
    public message: any = {};
    public working = false;
    public formGroup: UntypedFormGroup;

    constructor(
        private readonly dialog: MatDialogRef<FakturagodkendelseModalComponent>,
        @Inject(MAT_DIALOG_DATA) public readonly data: FakturagodkendelseModalData
    ) {}

    public ngOnInit(): void {
        this.formGroup = FakturagodkendelseModalFormBuilder.opretForm(this.data);
    }

    public ok(form: UntypedFormGroup): void {
        if (form.invalid) {
            return;
        }

        this.executeWorking(() => {
            const onOk = this.data.onOk({
                faktura: this.data.faktura,
                status: form.get("status").value,
                kodeord: form.get("kodeord").value,
                bemaerkning: form.get("bemaerkning").value
            });
            return Promise.resolve(onOk)
                .then(() => {
                    this.message = { message: this.data.successBesked, success: true };
                    setTimeout(() => {
                        this.dialog.close();
                        this.data.onOkSucceeded();
                    }, 1000);
                })
                .catch(() => {
                    this.message = { message: this.data.fejlBesked, success: false };
                    form.controls.kodeord.setErrors({ ugyldigKode: true });
                });
        });
    }

    private executeWorking(func: any): any {
        this.working = true;
        try {
            return func()
                .then(() => (this.working = false))
                .catch(() => (this.working = false));
        } catch (error) {
            this.working = false;
            this.message = { message: "Der er opstået en uventet fejl: " + error.message, success: false };
            return Promise.reject(error);
        }
    }
}
